import { NgModule, ApplicationRef } from '@angular/core';
import { APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule, Http } from '@angular/http';
import { removeNgStyles, createNewHosts } from '@angularclass/hmr';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { requestOptionsProvider } from './default-request-options.service';

import { AppRoutingModule } from './app.routing';
import { AppComponent } from './app.component';
import { UserBlockComponent } from './user-block.component';
import { MenuServiceBlockComponent } from './menu-service-block.component';
import { ServiceBlockBreacrumbComponent } from './service-block/breadcrumb.component';
import { MenuBlock } from './menu-service-block.model';
import { UserService }   from './services/';
import { ErrorService } from './errors/error.service';
import { AccountModule } from './account/module';
import { ProjectModule } from './projects/project.module';
import { CampaignModule } from './campaigns/campaign.module';
import { LandingModule } from './landing/landing.module';
import { SharedDataService } from './shared/data.service';

export function HttpLoaderFactory(http: Http) {
  return new TranslateHttpLoader(http, '/i18n/', '.json?' + process.env.VERSION);
}

export function initUser(user: UserService) {
 return () => user.load();
};

@NgModule({
  imports: [
    BrowserModule,
    HttpModule,
    AccountModule,
    ProjectModule,
    CampaignModule,
    LandingModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [Http]
      }
    })
  ],
  declarations: [
    AppComponent,
    UserBlockComponent,
    MenuServiceBlockComponent,
    ServiceBlockBreacrumbComponent
  ],
  providers: [
    requestOptionsProvider,
    ErrorService,
    UserService,
    MenuBlock,
    MenuServiceBlockComponent,
    SharedDataService,
    {
      'provide': APP_INITIALIZER,
      'useFactory': initUser,
      'deps': [UserService],
      'multi': true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(public appRef: ApplicationRef) {}

  hmrOnInit(store) {
    console.log('HMR store', store);
  }

  hmrOnDestroy(store) {
    let cmpLocation = this.appRef.components.map(cmp => cmp.location.nativeElement);
    // recreate elements
    store.disposeOldHosts = createNewHosts(cmpLocation);
    // remove styles
    removeNgStyles();
  }

  hmrAfterDestroy(store) {
    // display new elements
    store.disposeOldHosts();
    delete store.disposeOldHosts;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/app.module.ts